import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Confirm from "../../Components/confirm";
import { CommonUtil } from "../../utils/CommonUtil";
import ToastManager from "../../Components/ToastManager";
import { NetworkManager } from "../../Components/NetworkManager";
import { default as ReactSelect, components } from "react-select";
import ToggleSwitch from "../../Components/ToggleSwitch";
import { Modal } from "react-bootstrap";
import DraggableComponent from "../../Components/DraggableComponent";
import * as Yup from "yup";
import InputField from "../../Components/InputField";
import ReactSelectField from "../../Components/ReactSelectField";
import SelectField from "../../Components/SelectField";
let deletedIndex: any = null;

const Processes = ({unSavedChanges}:any) => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [processes, setProcesses] = useState<any>([]);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [allProcesses, setAllProcesses] = useState<any>([]);
  const [assetTypes, setAssetTypes] = useState<any>([]);
  const [equipmentTypes, setEquipmentTypes] = useState<any>([]);
  const [selectedOption, setSelectedOption] = useState<any>([]);
  const [unSaved, setUnSaved] = useState<boolean>(false);
  const [draggedItem, setDraggedItem] = useState<any>(null);
  const [prevAssetType, setPrevAssetType] = useState<any>("");
  const [assetType, setAssetType] = useState<any>("");
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [documentType, setDocumentType] = useState<any>([]);

  const inspectionStart: any = [
    { label: "Front", value: "Front" },
    { label: "Rear Back – Right", value: "Rear Back – Right" },
    { label: "Middle – Right", value: "Middle – Right" },
    { label: "Front – Right", value: "Front – Right" },
    { label: "Front – Left", value: "Front – Left" },
    { label: "Middle – Left", value: "Middle – Left" },
    { label: "Rear Back – Left", value: "Rear Back – Left" },
    { label: "Back", value: "Back" },
  ];

  useEffect(() => {
    getAllProcesses();
    getAllDocumentTypes();
    getAssetTypes();
    setSelectedOption([{ label: "All", value: 0 }]);
    addFormik.setFieldValue("equipmentTypes", [{ label: "All", value: 0 }]);
  }, []);

  useEffect(() => {
    const isDifferent =
      JSON.stringify(processes) !== JSON.stringify(allProcesses);
    setUnSaved(isDifferent);
    unSavedChanges(isDifferent);
  }, [processes, allProcesses]);

  const onLoginError = (err: any) => {
    console.log(err);
  };
  const getAllProcesses = () => {
    const orgUrl = `api/v2/config/processes/?orgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest( orgUrl, "", "", "GET", true, onGetAllProcesses, onLoginError );
  };

  const onGetAllProcesses = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        const updatedData = restData.map((process: any) => ({
          ...process,
          equipmentTypes: process.equipmentTypes.map((item: any) => {
            const key = Object.keys(item)[0];
            return { label: key, value: item[key] };
          }),
          processTypes: process.processTypes.map((item: any) => {
            return { label: item, value: item };
          }),
          documentType: process.processDocTypes.map((item: any) => {
            return { label: item.docTypeName, value: item.docTypeId };
          }),
        }));
        setAllProcesses(updatedData);
        setProcesses(updatedData);
      } else {
        setProcesses([]);
      }
    }
  };

  const getAllDocumentTypes = () =>{
    const orgUrl = `api/v2/config/document-types/all/?orgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, (dataObj: any) =>{
      if (dataObj) {
        const restData = JSON.parse(dataObj);
        if (restData && restData.length > 0) {
          const docType = restData?.map((item: any) => ({
            value: item.documentTypesId,
            label: item.documentTypesName,
          }));
          setDocumentType(docType);
        } else {
          setDocumentType([]);
        }
      }
    },
    onLoginError)
  };

  const getAssetTypes = () => {
    const orgUrl = `api/equipment/assettypes`;
    NetworkManager.sendJsonRequest( orgUrl, "", "", "GET", true, onGetAssetTypes, onLoginError );
  };
    
  const onGetAssetTypes = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        setAssetTypes(restData);
      } else {
        setAssetTypes([]);
      }
    }
  };

  const getEquipmentTypes = (assetTypeId:any) => {
    const orgUrl = `api/equipment/equipmenttypes/?assetTypeId=${assetTypeId}`;
    NetworkManager.sendJsonRequest( orgUrl, "", "", "GET", true, onGetEquipmentTypes, onLoginError );
  };

  const onGetEquipmentTypes = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        const modifiedData = restData.map((item:any) => ({
          value: item.key,
          label: item.value,
        }));
        setEquipmentTypes(modifiedData);
      } else {
        setEquipmentTypes([]);
      }
    }
  };

  const processTypeList:any = [
    { label: "CTPAT", value: "CTPAT" },
    { label: "General", value: "General" },
    { label: "Picture", value: "Picture" },
    { label: "Tire", value: "Tire" },
    { label: "Light", value: "Light" },
    { label: "Reefer", value: "Reefer" },
  ];

  const handleDelete = (processId: any, index: number) => {
    deletedIndex = index;
    Confirm.show("Confirm", `${unSaved ? "You have unsaved changes. Do you want to discard them and Delete this Process?" : "Would you like to delete this Process?"}`, [
      {
        label: "Yes",
        callback: function () {
          if (processId) {
            let docTypeDelAPI = `api/v2/config/processes/${processId}?orgId=${saasOrgId}`;
            NetworkManager.sendJsonRequest(docTypeDelAPI, "", "", "DELETE", true, onDeleteSuccess, onLoginError);
          }else{
            setProcesses((prevProcesses: any) => {
              const updatedProcesses = prevProcesses.filter((_: any, i: number) => i !== index);
              
              return updatedProcesses.map((process: any, idx: number) => ({
                ...process,
                sequenceId: idx + 1,
              }));
            });
            ToastManager.showToast("Process Removed", "Info");
          }
        },
      },
      { label: "No" },
    ]);
  };
  
  const onDeleteSuccess = (dataObj: any) => {
    if (dataObj) {
      var restData = CommonUtil.parseData(dataObj);
      if (!restData.errorMessage) {
        setProcesses((prevProcesses: any) => {
          const updatedProcesses = prevProcesses.filter((_: any, i: number) => i !== deletedIndex);
          
          return updatedProcesses.map((process: any, idx: number) => ({
            ...process,
            sequenceId: idx + 1,
          }));
        });
        ToastManager.showToast("Processes Deleted Successfully", "Info");
        deletedIndex = null;
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      getAllProcesses();
    }
  };
  const handleMultiSelect = (selectedOptions: any, key: any, formik: any) => {
    formik.setFieldValue(key, selectedOptions);
    if(key === "processTypes"){
      const isCTPATSelected = selectedOptions.some((opt: any) => opt.value === "CTPAT");
      if (isCTPATSelected) {
        formik.setFieldValue("stopOnCtpatFailure", true);
      } else {
        formik.setFieldValue("stopOnCtpatFailure", false);
      }
    }
  };
  
  const handleMultiSelectAll = (selectedOptions: any, key: any, formik: any) => {
    if (selectedOptions.some((option: any) => option.value !== 0)) {
      selectedOptions = selectedOptions.filter((option: any) => option.value !== 0);
    } else if (selectedOptions.length === 0) {
      selectedOptions = [{ label: "All", value: 0 }];
    }
  
    formik.setFieldValue(key, selectedOptions);
  };  

const handleEdit = (index: number, process: any) => {
  setEditIndex(index);
  setPrevAssetType(process.assetTypeId);

  editFormik.setValues({
    processName: process.processName,
    status: process.status,
    processTypes: process.processTypes,
    documentType: process?.documentType,
    assetTypeId: process.assetTypeId,
    equipmentTypes: process.equipmentTypes,
    stopOnCtpatFailure: process.stopOnCtpatFailure,
    processImagePath: process.processImagePath,
    processImageName: process.processImageName,
    isTaskSequenceBased: process?.isTaskSequenceBased,
  });

  getEquipmentTypes(process.assetTypeId);
  setSelectedOption(process.equipmentTypes);
};

const onAssetEditChange = (e: any) => {
  const newAssetType = e.target.value;

  if (newAssetType != prevAssetType) {
    editFormik.setFieldValue("equipmentTypes", [{ label: "All", value: 0 }]);
    setSelectedOption([{ label: "All", value: 0 }]);
  }

  setPrevAssetType(newAssetType);
  getEquipmentTypes(newAssetType);
};
 
const onAssetChange = (e: any) => {
  const newAssetType = e.target.value;
  if(assetType !== ""){
    if (newAssetType !== assetType) {
      addFormik.setFieldValue("equipmentTypes", [{ label: "All", value: 0 }]);
      setSelectedOption([{ label: "All", value: 0 }]);
    }
  }

  setAssetType(newAssetType);
  getEquipmentTypes(newAssetType);
};

const formikValidation = Yup.object().shape({
    assetTypeId: Yup.string()
      .required('Asset Type is required'),
    status: Yup.string()
      .required('Status is required'),
    processName: Yup.string()
      .trim()
      .min(3, 'Process Name must be at least 3 characters')
      .max(100, 'Process Name cannot exceed 100 characters')
      .required('Process Name is required'),
    processTypes: Yup.array()
      .min(1, 'At least one process type is required')
      .required('Process Type is required'),
    // equipmentTypes: Yup.array()
    // .min(1, 'At least one Equipment type is required')
    // .required('Equipment Type is required'),
    documentType: Yup.array()
    .min(1, 'At least one Document type is required')
    .required('Document Type is required'),

  });

  const addFormik = useFormik({
    initialValues: {
      processName: "",
      status: "",
      assetTypeId: "",
      equipmentTypes: [{ label: "All", value: 0 }],
      processTypes: [],
      documentType: "",
      stopOnCtpatFailure: true,
      processImagePath: "",
      processImageName: "",
      isTaskSequenceBased: true,
    },
    validationSchema: formikValidation,
    onSubmit: (values, { resetForm }) => {
      onSubmitForm(values)
      resetForm();
      setEquipmentTypes([]);
      setAssetType("");
      setShowPopup(false);
    },
  });  

  const editFormik = useFormik({
    initialValues: {
      processName: "",
      status: "",
      assetTypeId: "",
      equipmentTypes: [],
      processTypes: [],
      documentType: "",
      stopOnCtpatFailure: true,
      processImagePath: "",
      processImageName: "",
      isTaskSequenceBased: true,
    },
    validationSchema: formikValidation,
    onSubmit: (values, { resetForm }) => {
      onSubmitForm(values)
    },
  });

  const onSubmitForm = (values: any) => {
    const isEdit = editIndex !== null;
    const nameExists = processes.some(
      (doc: any) =>
        doc.processName.trim().toLowerCase() ===
        values.processName.trim().toLowerCase()
    );
  
    if (!isEdit && nameExists) {
      ToastManager.showToast("Process with same name already exists!", "Error");
      return;
    }
  
    setProcesses((prevProcesses: any) => {
        const isCtpat = values.processTypes?.some((opt: any) => opt.value === "CTPAT");

        if (isEdit) {
          return prevProcesses.map((process: any, index: number) =>
            index === editIndex
              ? {
                  ...process,
                  processName: values.processName || process.processName,
                  status: values.status || process.status,
                  assetTypeId: values.assetTypeId || process.assetTypeId,
                  equipmentTypes: values.equipmentTypes || process.equipmentTypes,
                  processTypes: values.processTypes.length > 0 ? values.processTypes : null,
                  documentType: values.documentType || process.documentType,
                  stopOnCtpatFailure: isCtpat ? values.stopOnCtpatFailure === true : null,
                  processImagePath: values.processImagePath,
                  processImageName: values.processImageName,
                  isTaskSequenceBased: values?.isTaskSequenceBased,
                }
              : process
          );
        } else {
          const newSequenceId =
            prevProcesses.length > 0
              ? Math.max(...prevProcesses.map((d: any) => d.sequenceId || 0)) + 1
              : 1;

          return [
            ...prevProcesses,
            {
              processId: null,
              processName: values.processName,
              status: values.status,
              assetTypeId: values.assetTypeId,
              equipmentTypes: values.equipmentTypes,
              processTypes: values?.processTypes?.length > 0 ? values.processTypes : null,
              documentType: values.documentType,
              stopOnCtpatFailure: isCtpat ? values.stopOnCtpatFailure === true : null,
              processImagePath: values.processImagePath,
              processImageName: values.processImageName,
              isTaskSequenceBased: values?.isTaskSequenceBased,
              sequenceId: newSequenceId,
              inspectionOrgId: saasOrgId,
              saasOrgId: saasOrgId,
            },
          ];
        }
      });
    if (isEdit) {
      setEditIndex(null);
    }
  };

  const handleBulkSubmit = () => {
    const payload = processes.map((process: any) => ({
      equipmentTypesId: process.equipmentTypes?.map((type: any) => type.value) || null,
      assetTypeId:process.assetTypeId,
      inspectionOrgId: process.inspectionOrgId,
      processId: process.processId,
      processName: process.processName,
      processTypes: process.processTypes?.map((type: any) => type.value) || null,
      processDocTypes: process.documentType?.map((item: any) => {
        return { docTypeName: item.label, docTypeId: item.value }
      }) || null,
      stopOnCtpatFailure: process.stopOnCtpatFailure == undefined ? null : process.stopOnCtpatFailure,
      processImagePath: process.processImagePath,
      processImageName: process.processImageName,
      isTaskSequenceBased: process?.isTaskSequenceBased == undefined ? null : process.isTaskSequenceBased,
      saasOrgId: process.saasOrgId,
      sequenceId: process.sequenceId,
      status: process.status,
    }));
    console.log("Processes Saved", payload)
  
    const url = `api/v2/config/processes/multiple?orgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onSubmitSuccess, onLoginError);
  };  
  
  const onSubmitSuccess = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && !restData.errorMessage) {
        ToastManager.showToast("Processes Saved Successfully", "Success");
        setProcesses([]);
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      getAllProcesses();
    }
  };
    
  const handleDragStart = (event: any, item: any) => {
    setDraggedItem(item);
    event.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  const handleDrop = (event: any, targetItem: any) => {
      event.preventDefault();
      if (
        !draggedItem ||
        draggedItem.processId === targetItem.processId
      )
        return;
  
      const updatedList = processes
        .map((item: any) => {
          if (typeof item.sequenceId === "undefined") {
            return { ...item, sequenceId: processes.length + 1 };
          }
          return item;
        })
        .map((item: any) => {
          if (item.processId === draggedItem.processId)
            return { ...item, sequenceId: targetItem.sequenceId };
  
          if (
            draggedItem.sequenceId < targetItem.sequenceId &&
            item.sequenceId > draggedItem.sequenceId &&
            item.sequenceId <= targetItem.sequenceId
          ) {
            return { ...item, sequenceId: item.sequenceId - 1 };
          }
          if (
            draggedItem.sequenceId > targetItem.sequenceId &&
            item.sequenceId < draggedItem.sequenceId &&
            item.sequenceId >= targetItem.sequenceId
          ) {
            return { ...item, sequenceId: item.sequenceId + 1 };
          }
          return item;
        })
        .sort((a: any, b: any) => a.sequenceId - b.sequenceId);
  
      setProcesses(updatedList);
      setDraggedItem(null);
      updateSequenceAPI(updatedList);
    };
  
    const updateSequenceAPI = async (updatedList: any) => {
      const payload = updatedList.map((item: any, index: any) => ({
        processName: item.processName,
        processId: item.processId,
        sequenceId: index + 1,
      }));
      const url = `api/v2/config/process/sequence?orgId=${saasOrgId}`;
      NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onUpdateSequence, onLoginError);
    };

    const onUpdateSequence = (dataObj: any) => {
      if (dataObj) {
        const restData = JSON.parse(dataObj);
        if (restData && !restData.errorMessage) {
          ToastManager.showToast("Sequence Updated Successfully", "Info");
        }else{
          ToastManager.showToast(restData.errorMessage, "Error");
        }
        getAllProcesses();
      }
    };

    const getProcessTypeOptions = (selectedOptions: any[]) => {
      const isCTPATSelected = selectedOptions?.some((opt: any) => opt.value === "CTPAT");

      return processTypeList.map((option: any) => {
        if (selectedOptions?.length === 0) {
          return {
            ...option,
          };
        } else if (isCTPATSelected) {
          return {
            ...option,
            isDisabled: option.value !== "CTPAT"
          };
        } else {
          return {
            ...option,
            isDisabled: option.value === "CTPAT"
          };
        }
      });
    };
    
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-40">
        <div className="col-lg-6 rounded bg-light">
          <div className={`d-flex p-3  ${processes.length > 0 ? "d-none" : ""}`}>
            <span>
              <i className="fa fa-info-circle me-3 icon-muted"></i>
            </span>
            <div className="fw-400 text-muted">
              <span className="fw-600 text-dark">
                No Processes added yet
              </span>
              <br></br>
            </div>
          </div>
        </div>
        <div className="col-lg-6 text-end">
          <button type="submit" className="btn btn-success" 
            onClick={()=>{
              addFormik.resetForm();
              setShowPopup(true);
            }}>
            <div className="d-flex justify-content-center align-item-center">
              Add New Process
            </div>
          </button>
          <button type="submit" className="btn btn-dark  ms-2" 
            onClick={handleBulkSubmit}
            disabled={!unSaved || editIndex !== null}>
            <div className="d-flex justify-content-center align-item-center">
              Save
            </div>
          </button>
        </div>
      </div>
      <div style={{overflowY: "auto", width:"100%", height:`${window.innerHeight - 220}px`, paddingRight:"12px"}}>
      <div className="col-lg-12">
        {processes.length > 0 && (
          <>
            <form onSubmit={editFormik.handleSubmit} className="mb-4">
              {processes.map((item: any, index: any) => (
                <div 
                  draggable={unSaved || editIndex !== null ? false : true}
                  onDragStart={(event) => handleDragStart(event, item)}
                  onDragOver={handleDragOver}
                  onDrop={(event) => handleDrop(event, item)}
                  key={index}
                  className={`create-card m-1 mb-3 p-4 processes ${unSaved || editIndex !== null ? "" : "drag-icon"}`}
                  style={{marginLeft: (unSaved || editIndex !== null) ? "0px drag-icon-empty" : "drag-icon",}}
                  title={unSaved || editIndex !== null ? "" : `Click, Hold, and Drag to set the right sequence`}
                >
                <div className="row mb-0">
                  <div className="col-md-4 mb-4">
                    <InputField
                      type="text"
                      name="processName"
                      placeholder="Process Name"
                      className="form-control"
                      onChange={editFormik.handleChange}
                      value={editIndex === index ? editFormik.values.processName : item.processName}
                      disabled={editIndex !== index}
                    />
                    {editFormik.touched.processName && editFormik.errors.processName && editIndex === index && (
                      <small className="ms-2 text-danger fw-700">{editFormik.errors.processName}</small>
                    )}
                  </div>
                  <div className="col-md-4 mb-4">
                      <SelectField
                        placeholder="Status"
                      name="status"
                      className="form-select"
                      value={editIndex === index
                        ? editFormik.values.status
                        : item.status}
                      onChange={editFormik.handleChange}
                      disabled={editIndex !== index}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </SelectField>
                  {editFormik.touched.status && editFormik.errors.status && editIndex === index && (
                    <small className="ms-2 text-danger fw-700">{editFormik.errors.status}</small>
                  )}
                  </div>
                  <div className="col-md-4 mb-4">
                    <ReactSelectField
                      placeholder= "Process Type"
                      name="processTypes"
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                      options={getProcessTypeOptions(
                        editIndex === index ? editFormik.values.processTypes : item.processTypes
                      )}
                      value={editIndex === index ? editFormik.values.processTypes : item.processTypes}
                      onChange={(selected:any) => handleMultiSelect(selected, "processTypes", editFormik)}
                      isDisabled={editIndex !== index || item?.isProcessEventExists === true}
                     
                    />
                    {editFormik.touched.processTypes && editFormik.errors.processTypes && editIndex === index && (
                      <small className="ms-2 text-danger fw-700">{editFormik.errors.processTypes}</small>
                    )}
                  </div>
                  <div className="col-md-4 mb-1">
                    <ReactSelectField
                      placeholder="Document Type"
                      name="documentType"
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                      options={[...documentType]}
                      value={editIndex === index ? editFormik.values.documentType : item.documentType}
                      onChange={(selected:any) => handleMultiSelect(selected, "documentType", editFormik)}
                      isDisabled={editIndex !== index}
                    />
                    {editFormik.touched.documentType && editFormik.errors.documentType && editIndex === index && (
                      <small className="ms-2 text-danger fw-700">{editFormik.errors.documentType}</small>
                    )}
                  </div>
                  <div className="col-md-4 mb-1">
                      <SelectField
                        placeholder="Asset Type"
                        name="assetTypeId"
                        className="form-select"
                        value={editIndex === index
                          ? editFormik.values.assetTypeId
                          : item.assetTypeId}
                        onChange={(e:any) => {
                          editFormik.handleChange(e);
                          onAssetEditChange(e);
                        }}
                        disabled={editIndex !== index}
                    >
                      {assetTypes.map((item:any, index:any) => (
                        <option value={item.key} key={index}>{item.value}</option>
                      ))}
                    </SelectField>
                  {editFormik.touched.assetTypeId && editFormik.errors.assetTypeId && editIndex === index && (
                    <small className="ms-2 text-danger fw-700">{editFormik.errors.assetTypeId}</small>
                  )}
                  </div>
                  <div className="col-md-4 mb-1">
                      <ReactSelectField
                        placeholder="Equipment Type"
                        name="equipmentTypes"
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                        options={[{ label: "All", value: 0 }, ...equipmentTypes]}
                        value={editIndex === index
                          ? editFormik.values.equipmentTypes
                          : item.equipmentTypes}
                        onChange={(selected:any) => handleMultiSelectAll(selected, "equipmentTypes", editFormik)}
                        isDisabled={editIndex !== index}
                      />
                      {editFormik.touched.equipmentTypes && editFormik.errors.equipmentTypes && editIndex === index && (
                        <small className="ms-2 text-danger fw-700">{editFormik.errors.equipmentTypes}</small>
                      )}
                  </div>
                  {(editIndex === index
                    ? editFormik.values.processTypes?.some((pt: any) => pt.value === "CTPAT")
                    : item.processTypes?.some((pt: any) => pt.value === "CTPAT")) && (
                    <div className="col-md-9 mb-1 mt-2">
                      <ToggleSwitch
                        label="Do not proceed with the Inspection process if any of the tasks are found to be non-compliant."
                        name="stopOnCtpatFailure"
                        checked={editIndex === index ? editFormik.values.stopOnCtpatFailure : item.stopOnCtpatFailure}
                        onChange={() => {
                          editFormik.setFieldValue("stopOnCtpatFailure", !editFormik.values.stopOnCtpatFailure);
                        }}
                        isDisabled={editIndex !== index}
                      />
                    </div>)}
                  <div className="col-md-4 mt-1 mb-4">
                    <ToggleSwitch
                      label="Follow Default Task Sequence."
                      name="isTaskSequenceBased"
                      checked={editIndex === index ? editFormik?.values?.isTaskSequenceBased : item?.isTaskSequenceBased}
                      isDisabled={editIndex !== index}
                      onChange={() => {
                        editFormik.setFieldValue("isTaskSequenceBased", !editFormik.values.isTaskSequenceBased);
                      }}
                    />
                  </div>
                </div>
                  <div className="row g-3 align-item-center mt-0">
                    <div className="col-md-12 d-flex justify-content-end align-items-end">
                      {editIndex !== index ? (
                        <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          title="Edit"
                          className="btn btn-icon"
                          onClick={(e) => {
                            e.preventDefault();
                            handleEdit(index, item)}}
                        >
                          <img src={"./../images/edit.svg"} alt="edit" width={18} height={18} />
                        </button>
                          <button
                            type="button"
                            title="Close"
                            className="btn btn-icon"
                            onClick={() => handleDelete(item.processId, index)}
                          >
                            <img src={"./../images/delete.svg"} alt="delete" width={18} height={18} />
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-icon"
                            title="Save"
                            disabled={
                              !editFormik.values.processName ||
                              !editFormik.values.status ||
                              !editFormik.values.assetTypeId
                            }
                          >
                            <img src={"./../images/check.svg"} alt="check" width={18} height={18} />
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-icon"
                            title="Cancel"
                            onClick={() => setEditIndex(null)}
                          >
                            <img src={"./../images/cancel.svg"} alt="cancel" width={18} height={18} />
                          </button>
                        </div>
                      )}
                    </div>
                </div>
                </div>
              ))}
            </form>
          </>
        )}
        </div>
        </div>
      <Modal show={showPopup} centered dialogAs={DraggableComponent} id="devEstPopup" size={`lg`}>
        <div
          className="modal-content new-interchange"
          id="devEstContentPopup"         
        >
          <Modal.Header className="modal-header" closeButton={false}>
            <h5 className="modal-title mt-0">Add New Process</h5>
            <button
              type="button"
              className="isModal"
              data-dismiss="modal"
              style={{ marginLeft: "0px", background: "none" }}
              aria-label="Close"
              onClick={()=>{
                addFormik.resetForm();
                setShowPopup(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
        <form onSubmit={addFormik.handleSubmit} className="modal-body">
          <div className="row">
            <div className="col-md-4 mb-4">
              <InputField
                type="text"
                autoFocus
                name="processName"
                placeholder="Process Name"
                className="form-control"
                value={addFormik.values.processName}
                onChange={addFormik.handleChange}
              />
              {addFormik.touched.processName && addFormik.errors.processName && (
                <small className="ms-2 text-danger fw-700">{addFormik.errors.processName}</small>
              )}
            </div>
            <div className="col-md-4 mb-4">
              <SelectField
                placeholder="Status"
                name="status"
                className="form-select"
                value={addFormik.values.status}
                onChange={addFormik.handleChange}
              >
                <option value="" disabled>Select</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </SelectField>
                  {addFormik.touched.status && addFormik.errors.status && (
                    <small className="ms-2 text-danger fw-700">{addFormik.errors.status}</small>
                  )}
            </div>
            <div className="col-md-4 mb-4">
              <ReactSelectField
                placeholder="Process Type"
                name="processTypes"
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                options={getProcessTypeOptions(addFormik.values.processTypes)}
                value={addFormik.values.processTypes}
                onChange={(selected:any) => handleMultiSelect(selected, "processTypes", addFormik)}
              
              />
              {addFormik.touched.processTypes && addFormik.errors.processTypes && (
                <small className="ms-2 text-danger fw-700">{addFormik.errors.processTypes}</small>
              )}
            </div>
            <div className="col-md-4 mb-2">
              <ReactSelectField
                placeholder="Document Type"
                name="documentType"
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                options={[...documentType]}
                value={addFormik.values.documentType}
                onChange={(selected:any) => handleMultiSelect(selected, "documentType", addFormik)}
               
              />
              {addFormik.touched.documentType && addFormik.errors.documentType && (
                <small className="ms-2 text-danger fw-700">{addFormik.errors.documentType}</small>
              )}
            </div>
            <div className="col-md-4 mb-2">
              <SelectField
                placeholder="Asset Type"
                name="assetTypeId"
                className="form-select"
                value={addFormik.values.assetTypeId}
                onChange={(e:any) => {
                  addFormik.handleChange(e);
                  onAssetChange(e);
                }}
              >
                <option value="" disabled>Select</option>
                {assetTypes.map((item:any, index:any) => (
                  <option value={item.key} key={index}>{item.value}</option>
                ))}
              </SelectField>
                {addFormik.touched.assetTypeId && addFormik.errors.assetTypeId && (
                  <small className="ms-2 text-danger fw-700">{addFormik.errors.assetTypeId}</small>
                )}
            </div>
            <div className="col-md-4 mb-2">
                <ReactSelectField
                  placeholder="Equipment Type"
                  name="equipmentTypes"
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                  options={[{ label: "All", value: 0 }, ...equipmentTypes]}
                  value={addFormik.values.equipmentTypes}
                  onChange={(selected:any) => handleMultiSelectAll(selected, "equipmentTypes", addFormik)}
                  isDisabled={equipmentTypes.length === 0} 
                
                />
            </div>
            {addFormik.values.processTypes?.some((pt: any) => pt.value === "CTPAT") && (
              <div className="col-md-12 mb-1">
                <ToggleSwitch
                  label="Do not proceed with the Inspection process if any of the tasks are found to be non-compliant."
                  name="stopOnCtpatFailure"
                  checked={addFormik.values.stopOnCtpatFailure}
                  onChange={() => {
                    addFormik.setFieldValue("stopOnCtpatFailure", !addFormik.values.stopOnCtpatFailure);
                  }}
                />
              </div>
            )}
            <div className="col-md-6 mb-4">
              <ToggleSwitch
                label="Follow Default Task Sequence."
                name="isTaskSequenceBased"
                checked={addFormik.values.isTaskSequenceBased}
                onChange={() => {
                  addFormik.setFieldValue("isTaskSequenceBased", !addFormik.values.isTaskSequenceBased);
                }}
              />
            </div>
          </div>
          <div className={`row g-3 align-item-center my-1`}>
            <div className="col-lg-12 d-flex justify-content-end align-items-end">
              <button type="submit" className="btn btn-dark d-flex align-items-center"
                  disabled={
                    !addFormik.values.processName ||
                    !addFormik.values.status ||
                    !addFormik.values.assetTypeId
                  }                
                >
                  <i className="fa-solid fa-plus me-2"></i> Add
                </button>
                <button type="button" className="btn btn-outline-light ms-1"
                  onClick={()=>{
                    addFormik.resetForm();
                    setShowPopup(false);
                  }}
                >
                  Cancel
                </button>
            </div>
          </div>
        </form>
        </div>
      </Modal>
    </>
  );
};

const CustomMultiValue = ({ data, index, selectProps }: any) => {
  const selectedValues = selectProps.value || [];
  if (index !== 0) return null;

  const totalCharCount = selectedValues.reduce((acc: number, item: any) => acc + item.label.length, 0);

  let visibleCount = 3;
  if (totalCharCount > 25) {
    visibleCount = 1;
  } else if (totalCharCount > 15) {
    visibleCount = 2;
  }

  const visibleLabels = selectedValues.slice(0, visibleCount).map((item: any) => item.label);
  const remainingCount = selectedValues.length - visibleCount;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      <span>{visibleLabels.join(", ")}</span>
      {remainingCount > 0 && (
        <span className="count-badge" style={{ marginLeft: 5 }}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};



const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />
      <label style={{ marginLeft: "8px" }}>{props.label}</label>
    </components.Option>
  );
};
export default Processes;
